// extracted by mini-css-extract-plugin
export default {"outerDiv":"AddAddressCard_outerDiv__aEtGa","innerDiv":"AddAddressCard_innerDiv__LlPEe","img":"AddAddressCard_img__U82nT","txt":"AddAddressCard_txt__TMYfk"};